module.exports = __webpack_public_path__ + "static/media/SCHAALKLEURSTOF_06.a89f8b6a.png";